import React from "react"
import { Phone, Headset, Mail } from "lucide-react"
import "../styles/navbar.css"

const ContactButtons = () => {
  return (
    <div className="contact-buttons">
      <a href="tel:+33983519498" className="contact-button" aria-label="Appeler">
        <Phone style={{ width: "20px", height: "20px" }}/>
      </a>
      <a href="tel:+33 9 83 51 94 98" className="contact-button" aria-label="Support">
        <Headset style={{ width: "20px", height: "20px" }} />
      </a>
      <a href="mailto:contact@bisma.fr" className="contact-button" aria-label="Envoyer un email">
        <Mail style={{ width: "20px", height: "20px" }} />
      </a>
    </div>
  )
}

export default ContactButtons
